import React from 'react';
import { useLanguage } from '../LanguageContext';
import { useScrollReveal } from '../hooks/useScrollReveal';

const BetterWay = () => {
  const { t } = useLanguage();
  const ref = useScrollReveal(['.section-title', '.better-card'], { stagger: 0.14 });

  return (
    <section className="better-way-section" id="services" ref={ref}>
      <h2 className="section-title" style={{ textAlign: 'center', marginBottom: '3rem' }}>
        {t.betterWay.title}
      </h2>
      <div className="better-grid">
        <div className="better-card">
          <img src="https://images.unsplash.com/photo-1541367777708-7905fe3296c0?w=800&q=80" alt="Travel" />
          <div className="better-card-content">
            <h3>{t.betterWay.card1.title}</h3>
            <p>{t.betterWay.card1.text}</p>
          </div>
        </div>
        <div className="better-card">
          <img src="https://images.unsplash.com/photo-1436491865332-7a61a109cc05?w=800&q=80" alt="Jet runway" />
          <div className="better-card-content">
            <h3>{t.betterWay.card2.title}</h3>
            <p>{t.betterWay.card2.text}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BetterWay;
